import axios from 'axios'
import { orderService_dotnet, shopService_dotnet, generalService_dotnet } from '@/website/global'

// ทุกการเรียก API ของ OMS อยู่ที่ไฟล์นี้ที่เดียว หน้าจอไม่เรียก axios เอง

const NOT_OMS_KEY = 'oms_not_user_token'
const OMS_USER_KEY = 'oms_user'
let contextPromise = null

function headerToken () {
  return { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + localStorage.getItem('authorization_token') }
}

export async function omsPost (action, body, timeout) {
  try {
    const response = await axios.post(orderService_dotnet + 'Oms/' + action, body || {}, { headers: headerToken(), timeout: timeout || 0 })
    return response.data
  } catch (e) {
    return { status: 'error', errorCode: 'NETWORK', message: null }
  }
}

// ช่องทาง, role และ location ของผู้ใช้ที่ login
// ผู้ใช้ที่ไม่ใช่ผู้ใช้ OMS จะถูกจำไว้ตาม token จึงเรียก API แค่ครั้งเดียวต่อการ login
export function getOmsContext () {
  const token = localStorage.getItem('authorization_token')
  if (token == null || localStorage.getItem(NOT_OMS_KEY) === token) {
    return Promise.resolve({ isOmsUser: false, locations: [] })
  }
  if (contextPromise == null) {
    // เมนูและการเปลี่ยนหน้าครั้งแรกหลัง login รอผลนี้ จึงจำกัดเวลาไว้ไม่ให้ค้างเมื่อ service ช้าหรือล่ม
    contextPromise = omsPost('get-my-context', {}, 8000).then(data => {
      if (data.status !== 'success') {
        // เรียกไม่สำเร็จ: ไม่ลองซ้ำจนกว่าจะโหลดหน้าใหม่ และคงสถานะที่รู้อยู่เดิมไว้
        const role = getKnownOmsRole()
        return { isOmsUser: role != null, role: role, locations: [], isUnavailable: true }
      }
      if (data.isOmsUser) {
        localStorage.setItem(OMS_USER_KEY, JSON.stringify({ token: token, role: data.role }))
      } else {
        localStorage.removeItem(OMS_USER_KEY)
        localStorage.setItem(NOT_OMS_KEY, token)
      }
      return data
    })
  }
  return contextPromise
}

// role ของผู้ใช้ OMS ที่รู้แล้วจากการเรียกครั้งก่อนของ token นี้ (null = ไม่ใช่ผู้ใช้ OMS หรือยังไม่รู้)
// ใช้ตัดสินแบบทันทีโดยไม่ต้องรอ API เช่น ซ่อนเมนูเดิมตั้งแต่เฟรมแรก
export function getKnownOmsRole () {
  try {
    const known = JSON.parse(localStorage.getItem(OMS_USER_KEY))
    return known != null && known.token === localStorage.getItem('authorization_token') ? known.role : null
  } catch (e) {
    return null
  }
}

// รู้แล้วหรือยังว่าผู้ใช้ที่ login อยู่เป็นผู้ใช้ OMS หรือไม่ (ยังไม่รู้ = เพิ่ง login และยังไม่เคยเรียก get-my-context)
export function isOmsStatusKnown () {
  const token = localStorage.getItem('authorization_token')
  return token == null || localStorage.getItem(NOT_OMS_KEY) === token || getKnownOmsRole() != null
}

// Location
export const getLocationList = body => omsPost('get-location-list', body)
export const saveLocation = body => omsPost('save-location', body)
export const importLocation = rows => omsPost('import-location', { rows })

// Quota
export const getQuotaLocationList = () => omsPost('get-quota-location-list')
export const getQuotaList = body => omsPost('get-quota-list', body)
export const saveQuota = body => omsPost('save-quota', body)
export const importQuota = rows => omsPost('import-quota', { rows })
export const getQuotaSummary = body => omsPost('get-quota-summary', body)

// Stock / Store
export const getStockList = body => omsPost('get-stock-list', body)
export const getStoreList = body => omsPost('get-store-list', body)
export const importStore = rows => omsPost('import-store', { rows })
export const saveStore = body => omsPost('save-store', body)

// รายการรหัสไปรษณีย์ / ตำบล / อำเภอ / จังหวัด จาก API เดิมของระบบ โหลดครั้งเดียวต่อการเปิดหน้า
// แต่ละรายการมี Id, Postcode, Province, District, SubDistrict
let postcodeMappingPromise = null
export function getPostcodeMappingList () {
  if (postcodeMappingPromise == null) {
    postcodeMappingPromise = axios.post(generalService_dotnet + 'General/get-postcodeMapping', {}, { headers: headerToken() })
      .then(response => response.data || [])
      .catch(() => {
        postcodeMappingPromise = null
        return []
      })
  }
  return postcodeMappingPromise
}

// Order request (ON)
export const createOrderRequest = body => omsPost('create-order-request', body)
export const updateOrderRequest = body => omsPost('update-order-request', body)
export const cancelOrderRequest = tempId => omsPost('cancel-order-request', { tempId })
export const getOrderRequestList = body => omsPost('get-order-request-list', body)
export const getOrderRequestCount = body => omsPost('get-order-request-count', body)
export const getCreatorList = () => omsPost('get-creator-list')
export const getOrderRequestDetail = tempId => omsPost('get-order-request-detail', { tempId })
export const approveOrderRequest = tempIds => omsPost('approve-order-request', { tempIds })
export const rejectOrderRequest = (tempId, reason) => omsPost('reject-order-request', { tempId, reason })

// ค่าเริ่มต้นของออเดอร์ที่ผู้ใช้ OMS ไม่ได้เลือกเอง อ่านจากการตั้งค่าของ shop ด้วย API เดิมของระบบ
// (ที่อยู่ผู้ส่ง ขนส่ง และช่องทางขาย ชุดเดียวกับที่หน้าสร้างออเดอร์เดิมใช้เป็นค่าเริ่มต้น)
// uniqueID ของขนส่ง = "branchExpress_shopExpress_expressCompany" โดย 0 หมายถึงไม่มี (รูปแบบเดียวกับหน้าสร้างออเดอร์เดิม)
export function parseExpressUniqueId (uniqueId) {
  if (uniqueId == null || uniqueId === '') {
    return { branchExpressID: null, shopExpressID: null, expressCompanyId: null }
  }
  const parts = String(uniqueId).split('_').map(text => parseInt(text))
  return {
    branchExpressID: parts[0] || null,
    shopExpressID: parts[1] || null,
    expressCompanyId: isNaN(parts[2]) ? null : parts[2]
  }
}

export function buildExpressUniqueId (orderMaster) {
  return [orderMaster.branchExpressID || 0, orderMaster.shopExpressID || 0, orderMaster.expressCompanyId || 0].join('_')
}

// ตัวเลือกขนส่งและช่องทางการขายของ shop พร้อมค่าเริ่มต้น (คืนใน expressList, channelList, expressUniqueId)
export async function getOrderDefaults () {
  const shopId = localStorage.getItem('shop_id')
  const defaults = { shopAddressId: null, expressCompanyId: null, shopExpressID: null, branchExpressID: null, referenceSourceId: 0 }
  const options = { expressList: [], channelList: [], expressUniqueId: null }
  try {
    const [express, address, channel] = await Promise.all([
      axios.post(shopService_dotnet + 'Shop/get-shop-express-addorder', { shopID: shopId }, { headers: headerToken() }),
      axios.post(shopService_dotnet + 'ShopAddress/get-shop-address-list', { shopID: shopId }, { headers: headerToken() }),
      axios.post(shopService_dotnet + 'Shop/get-shop-channel', { shopID: shopId }, { headers: headerToken() })
    ])

    const expressList = express.data || []
    // ค่าเริ่มต้นแบบเดียวกับหน้าเดิม: ตัวที่ตั้งเป็นค่าเริ่มต้น ถ้าไม่มีใช้ตัวที่สองเมื่อมีมากกว่าหนึ่ง
    const chosenExpress = expressList.find(item => item.isDefault == true) || (expressList.length > 1 ? expressList[1] : expressList[0])
    options.expressList = expressList
    if (chosenExpress != null && chosenExpress.uniqueID != null) {
      options.expressUniqueId = String(chosenExpress.uniqueID)
      Object.assign(defaults, parseExpressUniqueId(chosenExpress.uniqueID))
    }

    const addressList = address.data || []
    const chosenAddress = addressList.find(item => item.isDefault == true) || addressList[addressList.length - 1]
    defaults.shopAddressId = chosenAddress != null ? chosenAddress.id : null

    const channelList = (channel.data || []).filter(item => item.shopId != null || [1, 2, 7].includes(item.id))
    options.channelList = channelList
    defaults.referenceSourceId = channelList.length > 0 ? channelList[0].id : 0
    return { status: 'success', defaults, ...options }
  } catch (e) {
    return { status: 'error', errorCode: 'NETWORK', message: null, defaults, ...options }
  }
}

// User
export const getUserList = body => omsPost('get-user-list', body)
export const saveUser = body => omsPost('save-user', body)

// ส่วนที่แตะบัญชี staff (สร้างบัญชี, รหัสผ่าน) อยู่ที่ shop service ส่วนสิทธิ์ของผู้ใช้ที่มีอยู่แล้วอยู่ที่ order service
async function omsUserPost (action, body) {
  try {
    const response = await axios.post(shopService_dotnet + 'OmsUser/' + action, body || {}, { headers: headerToken() })
    return response.data
  } catch (e) {
    return { status: 'error', errorCode: 'NETWORK', message: null }
  }
}

// สร้างบัญชีใหม่พร้อมสิทธิ์ OMS ในครั้งเดียว บัญชีที่ได้ไม่มีสิทธิ์เมนูเดิมของระบบ
export const createUser = body => omsUserPost('create-user', body)
export const changePassword = body => omsUserPost('change-password', body)
export const deleteUser = staffShopId => omsPost('delete-user', { staffShopId })
export const importUser = rows => omsPost('import-user', { rows })
